import { Button, Stack } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onApply: () => void;
  onCancel: () => void;
  disabled: boolean;
};

const RESOURCES = Resources.Components.Merchant.Facilities.Form.OpeningHours;

export const BulkEditActions = ({ onApply, onCancel, disabled }: Props) => {
  const { t } = useResource();

  const applyAndClose = () => {
    onApply();
    onCancel();
  };

  return (
    <Stack direction={["column", "row"]} gap={2} mt={2}>
      <Button
        onClick={applyAndClose}
        disabled={disabled}
        variant="contained"
        color="primary"
        sx={{
          width: ["100%", "auto"],
          "&.Mui-disabled": {
            color: ({ palette }) => palette.common.white,
          },
        }}
      >
        {t(RESOURCES.ApplyToSelected)}
      </Button>
      <Button
        variant="text"
        onClick={onCancel}
        sx={{ width: ["100%", "auto"] }}
      >
        {t(RESOURCES.Cancel)}
      </Button>
    </Stack>
  );
};
